import React, { Component } from 'react'
import 'react-toastify/dist/ReactToastify.css'
import { Row, Col, Form, FormControl, Button } from 'react-bootstrap'
import messagesApi from '../../api/messages.api'
import { toast } from 'react-toastify'
import UsersApi from '../../api/users.api'
import { MessageTypes } from '../../common/enums'
import UploadsAPI from '../../api/uploads.api'
import Cookies from "js-cookie";
import { isValidMacedonianNumber } from "../../utils/numbers";

export default class FileOnly extends Component {
  constructor(props) {
    super(props)
    this.state = {
      imageUrl: '',
      imageUrlErr: null,
      selectedFile: null,
      selectedimage: null,
      imageFileErr: null,
      imageFileName: '',
      originalFileName: '',
      numbersFileName: '',
      number: "",
      isSuperAdmin: Cookies.get("isSuperAdmin") === "true",
      fileExtension: '',
    }
    this.SendBulk = this.SendBulk.bind(this)
    this.onChangeFileHandler = this.onChangeFileHandler.bind(this)
    this.onChangeHandler = this.onChangeHandler.bind(this)
  }

  getMessageType(extension) {
    const ext = extension.toLowerCase();
    if (ext === 'png' || ext === 'jpg' || ext === 'jpeg') {
      return MessageTypes.ImageOnly;
    } else if (ext === 'pdf') {
      return MessageTypes.FileOnly;
    }
    return MessageTypes.FileOnly;
  }

  async SendBulk() {
    this.setState({ messageText: '' })

    if (this.validateForm()) {
      const messageType = this.getMessageType(this.state.fileExtension);
      const fileUrl = `${process.env.REACT_APP_IMAGES_URL}/${this.state.imageFileName}`;

      await messagesApi.sendBulk({
        fileName: this.state.numbersFileName,
        tagLbl: this.props.tagLabel,
        btnUrl: fileUrl,
        fileType: this.state.fileExtension,
        nameOfFile: this.state.originalFileName,
        messageType: messageType,
        number: this.state.number
      })
      this.props.resetState()
      this.setState({
        imageUrl: '',
        imageUrlErr: null,
        selectedFile: null,
        selectedimage: null,
        imageFileErr: null,
        imageFileName: '',
        originalFileName: '',
        numbersFileName: '',
        fileExtension: '',
      })
      toast.success('Пораката беше испратена')
    }
  }

  async onChangeFileHandler(event) {
    try {
      const originalFile = event.target.files[0];
      const target = originalFile.name.slice(
        ((originalFile.name.lastIndexOf('.') - 1) >>> 0) + 2,
      )
      if (target.toLowerCase() == 'png' || target.toLowerCase() == 'jpg' || target.toLowerCase() == 'jpeg' || target.toLowerCase() == 'pdf') {
        const data = new FormData()
        data.append('file', originalFile)
        var response = await UploadsAPI.uploadImage(data)
        this.setState({
          imageFileName: response.data.filename,
          originalFileName: originalFile.name,
          fileError: '',
          fileExtension: target.toLowerCase()
        })
      } else {
        this.setState({
          imageFileErr:
            'Неправилен формат на фајл. Форматот мора да биде .png, .jpg или .pdf',
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  async onChangeHandler(event) {
    try {
      const target = event.target.files[0].name.slice(
        ((event.target.files[0].name.lastIndexOf('.') - 1) >>> 0) + 2,
      )
      if (target.toLowerCase() == 'xlsx') {
        const data = new FormData()
        data.append('file', event.target.files[0])
        var response = await UsersApi.uploadNumbers(data)
        this.setState({
          numbersFileName: response.data.filename,
          fileError: '',
        })
      } else {
        this.setState({
          fileError: 'Неправилен формат на фајл. Форматот мора да биде .xlsx',
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  validateForm() {
    let formValid = true
    console.log(this.props)

    if (this.props.imageUrl == '') {
      if (this.state.imageFileName == '') {
        this.setState({
          imageUrlErr: 'Ве молиме прикачете датотека (слика или PDF)',
        })
        formValid = false
      }
    }
    if (this.props.tagLabel == '') {
      this.setState({ tagLabelErr: 'Ве молиме внесете ознака за кампања' })
      formValid = false
    }
    if (this.state.isSuperAdmin && this.state.numbersFileName == '') {
      this.setState({ fileError: 'Ве молиме одберете датотека со броеви' })
      formValid = false
    }
    return formValid
  }
  render() {
    return (
      <Col>
        <Form>
          <Form.Group as={Row}>
            <Col sm="10">
              <Col>
                <label className="col-md-12 pl-0 bold-text">
                  Одберeте датотека (слика или PDF)
                </label>
                <input
                  type="file"
                  name="imageFileName"
                  onChange={this.onChangeFileHandler}
                  value={this.state.selectedFile}
                  accept=".png,.jpg,.jpeg,.pdf"
                />
                <p className="error">{this.state.imageUrlErr}</p>
              </Col>
              <Col xs={12} md={6} className="mt-4">
                <label className="bold-text">Ознака на кампања</label>
                <FormControl
                  type="text"
                  placeholder="Внесете ознака на кампањата"
                  onChange={this.props.handleChange}
                  name="tagLabel"
                  value={this.props.tagLabel}
                ></FormControl>
                <p className="error">{this.state.tagLabelErr}</p>
              </Col>
              <Col xs={12} md={6} className="mt-4">
                <label className="col-md-12 pl-0 bold-text">
                  {this.state.isSuperAdmin ? "Одберeте датотека со броеви" : "Внесете броj"}
                </label>
                {this.state.isSuperAdmin ? (
                  <input
                    type="file"
                    name="numbersFileName"
                    onChange={this.onChangeHandler}
                    value={this.state.selectedFile}
                  />
                ) : (
                  <FormControl
                    type="text"
                    placeholder="Внесете број во формат 3897xxxxxxx"
                    name="number"
                    value={this.state.number}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (isValidMacedonianNumber(value) || value === "") {
                        this.setState({ number: value, fileError: "" });
                      } else {
                        this.setState({ number: value, fileError: "Бројот мора да почнува со 3897 и да има вкупно 12 цифри." });
                      }
                    }}
                    maxLength={12}
                  />
                )}
                <p className="error">{this.state.fileError}</p>
              </Col>
              <Col xs={12} md={6} className="mt-4">
                <Button
                  onClick={this.SendBulk}
                  sm="3"
                  size="sm"
                  className="margin-top-10px button-standard"
                >
                  Испрати
                </Button>
              </Col>
            </Col>
          </Form.Group>
          <Form.Group as={Row}></Form.Group>
        </Form>
      </Col>
    )
  }
}
